module.exports = __webpack_public_path__ + "assets/media/chat-emote.670f6339.mp3";